export const ICON_SIZE = 24;
export const ICON_SIZE_SMALLER = 16;
